import { useEffect, useState, forwardRef } from 'react';
import cm from 'classnames';

import { ProjectFile } from 'services/file.service';
import { getVideoUrl } from 'components/app/_helpers/_app.helper';

import { Loader } from 'components/UI/loader/loader';
import styles from './_selector-player.module.scss';

interface Props {
  file?: ProjectFile;
  setInit: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SrPlayerImg = forwardRef<HTMLImageElement, Props>(({ file, setInit }: Props, ref) => {
  const [isImageLoading, setImageLoading] = useState<boolean>(false);

  const onLoad = () => {
    setImageLoading(false);
    setInit(true);
  };

  useEffect(() => {
    setImageLoading(true);
  }, [file?.id]);

  return (
    <div
      className={cm(styles.SrPlayerImg, {
        [styles['SrPlayerImg--loading']]: isImageLoading,
      })}
    >
      {file && <img ref={ref} crossOrigin="anonymous" src={getVideoUrl(file)} onLoad={onLoad} />}
      <Loader className={styles.SrPlayerImg__loader} />
    </div>
  );
});

SrPlayerImg.displayName = 'SrPlayerImg';
